import { memo } from "react";
import "./TaxesFeesInfo.scss";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import propTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import Popover from "app/components/ui/Popover/Popover";

const TaxesFeesInfo = ({ amount }) => {
	if (!amount) {
		return null;
	}

	return (
		<div className="taxes-fees-info">
			<div className="taxes-fees-info__title">
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
					<FormattedMessage id="taxes.fees.due.property" />{" "}
				</Typography>
				<Popover>
					<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} component="span">
						<FormattedMessage id="taxes.fees.local.notice" />
					</Typography>
				</Popover>
			</div>

			<AmountContainer amount={amount} prefix={"+"} isBold={false} />
		</div>
	);
};

TaxesFeesInfo.propTypes = {
	amount: propTypes.number,
};

export default memo(TaxesFeesInfo);
